import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for /projekte. Liste in projekte.index.tsx, Detail in
 * projekte.$id.tsx, Neuanlage in projekte.neu.tsx (Phase 5 Stufe I,
 * Slice 5).
 */
export const Route = createFileRoute('/projekte')({
  component: ProjekteLayout,
});

function ProjekteLayout(): JSX.Element {
  return <Outlet />;
}
